import { DEFAULT_SORT_VALUE } from '@/utils/constants';

export function parseSunglassesPage(page?: string): number {
  const parsedPage = Number.parseInt(page || '1', 10);
  return Number.isFinite(parsedPage) && parsedPage > 0 ? parsedPage : 1;
}

export function parseSunglassesFilter(filter?: string): Record<string, unknown> {
  if (!filter || filter === '{}') return {};

  try {
    const parsedFilter: unknown = JSON.parse(filter);
    return parsedFilter && typeof parsedFilter === 'object' && !Array.isArray(parsedFilter)
      ? (parsedFilter as Record<string, unknown>)
      : {};
  } catch {
    return {};
  }
}

interface SunglassesQueryUpdates {
  groupId?: number | null;
  sort?: string;
  filter?: Record<string, unknown>;
  page?: number;
}

function hasFilterValue(value: unknown): boolean {
  return Array.isArray(value) ? value.length > 0 : Boolean(value);
}

/** 与 goods-list 一致：默认值不写入 URL，其余交互状态写入 query。 */
export function buildSunglassesUrl(
  pathname: string,
  currentQueryString: string,
  updates: SunglassesQueryUpdates,
): string {
  const nextSearchParams = new URLSearchParams(currentQueryString);

  if (updates.groupId !== undefined) {
    if (updates.groupId === null) nextSearchParams.delete('group_id');
    else nextSearchParams.set('group_id', String(updates.groupId));
  }

  if (updates.sort !== undefined) {
    if (updates.sort && updates.sort !== DEFAULT_SORT_VALUE) {
      nextSearchParams.set('sort', updates.sort);
    } else {
      nextSearchParams.delete('sort');
    }
  }

  if (updates.filter !== undefined) {
    const cleanFilter = Object.fromEntries(
      Object.entries(updates.filter).filter(
        ([key, value]) => key !== 'init' && hasFilterValue(value),
      ),
    );
    if (Object.keys(cleanFilter).length > 0) {
      nextSearchParams.set('filter', JSON.stringify(cleanFilter));
    } else {
      nextSearchParams.delete('filter');
    }
  }

  if (updates.page !== undefined) {
    if (updates.page <= 1) nextSearchParams.delete('page');
    else nextSearchParams.set('page', String(updates.page));
  }

  const queryString = nextSearchParams.toString();
  return `${pathname}${queryString ? `?${queryString}` : ''}`;
}
